class BalanceProgressiveDiscount {
  constructor(container) {
    this.container = container;
    this.options = Array.from(container.querySelectorAll('.progressive-discount__option'));
    this.init();
  }

  init() {
    this.options.forEach((option) => {
      option.addEventListener('click', () => this.selectOption(option));
    });

    const selectedOption = this.container.querySelector('.progressive-discount__option--selected');
    if (selectedOption) {
      this.selectOption(selectedOption);
    }
  }

  selectOption(option) {
    const variantId = option.dataset.variantId;
    const packageCount = Number(option.dataset.packageCount) || 1;
    const cartQuantity = Number(option.dataset.cartQuantity) || packageCount;

    this.options.forEach((item) => {
      item.classList.remove('progressive-discount__option--selected');
    });

    option.classList.add('progressive-discount__option--selected');

    if (!variantId) {
      this.dispatchSelection(option);
      return;
    }

    this.updateVariantInput(variantId);
    this.setFormQuantity(cartQuantity);
    this.dispatchSelection(option);
  }

  dispatchSelection(option) {
    document.dispatchEvent(new CustomEvent('balance-progressive-discount:change', {
      detail: {
        packageCount: Number(option.dataset.packageCount) || 1,
        totalUnits: Number(option.dataset.totalUnits) || 30,
        variantId: option.dataset.variantId || '',
        cartQuantity: Number(option.dataset.cartQuantity) || Number(option.dataset.packageCount) || 1,
        productId: option.dataset.productId || '',
        price: Number(option.dataset.optionPrice) || 0,
        comparePrice: Number(option.dataset.optionComparePrice) || 0,
        savings: Number(option.dataset.savings) || 0,
        discountPercentage: Number(option.dataset.discountPercentage) || 0
      }
    }));
  }

  getForm() {
    return (
      this.container.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  getVariantInput() {
    const form = this.getForm();

    if (form) {
      const input = form.querySelector('input[name="id"]');

      if (input) {
        return input;
      }
    }

    return document.querySelector('input[name="id"]');
  }

  updateVariantInput(variantId) {
    const input = this.getVariantInput();

    if (!input) {
      return;
    }

    input.removeAttribute('disabled');
    input.value = String(variantId);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));

    const variantPicker = document.querySelector('product-variant-picker');
    const pickerSelect = variantPicker && variantPicker.querySelector('select[name="id"]');

    if (pickerSelect) {
      pickerSelect.value = String(variantId);
      pickerSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  setFormQuantity(quantity) {
    const form = this.getForm();

    if (!form) {
      return;
    }

    form.querySelectorAll('input[name="quantity"]').forEach((input) => {
      input.value = String(quantity);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
}

function initBalanceProgressiveDiscount() {
  document.querySelectorAll('[data-balance-progressive-discount]').forEach((container) => {
    if (container.dataset.initialized === 'true') {
      return;
    }

    container.dataset.initialized = 'true';
    new BalanceProgressiveDiscount(container);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBalanceProgressiveDiscount);
} else {
  initBalanceProgressiveDiscount();
}

document.addEventListener('shopify:section:load', initBalanceProgressiveDiscount);
